import {
  Component, Output, EventEmitter
} from '@angular/core';
import { formService } from '../Service/formService';
import { each as _each } from 'lodash-es';
import { ePayService } from "../Service/ePayService";
import { Session_CardModel } from '../Models/Model/Session_CardModel';
import { cardConnectService } from '../Service/cardConnectService';
import { HttpClient } from '@angular/common/http';
import { Session_Credit_Card_RequestModel } from '../Models/Model/Session_Credit_Card_RequestModel';

declare const google: any;

@Component({
  selector: 'google-pay',
  templateUrl: 'googlepay.component.html',
  styleUrls: ['googlepay.component.css'],
  exportAs: 'ngModel'
})
export class GooglePayComponent {
  public canMakePayment: boolean = false;
  private CardConnectService: cardConnectService;

  @Output() makePayment = new EventEmitter<any>();
  paymentsClient: any;

  constructor(
    private FormService: formService,
    private httpClient: HttpClient
  ) {
    this.CardConnectService = new cardConnectService(httpClient);
  }

  get EPayService(): ePayService {
    return this.FormService.EPayService;
  }

  ngOnInit() {
    this.canDoGooglePay();
  }

  IsInTestingMode = () => {
    if (this.FormService) {
      if (this.FormService.EPayService) {
        if (this.FormService.EPayService.ePay) {
          if (this.FormService.EPayService.ePay.xmlPayment) {
            if (this.FormService.EPayService.ePay.xmlPayment.agency) {
              if (this.FormService.EPayService.ePay.xmlPayment.agency.type) {
                return !(this.FormService.EPayService.ePay.xmlPayment.agency.type === 'Production' || this.FormService.EPayService.ePay.xmlPayment.agency.type === 'Authorization');
              }
            }
          }
        }
      }
    }
  }

  private googleRetryCount = 0;
  private maxRetries = 10;

  public canDoGooglePay = (): void => {
    const g = (window as any).google;

    if (!g || !g.payments?.api) {
      this.googleRetryCount++;

      if (this.googleRetryCount > this.maxRetries) {
        console.warn('Google Pay unavailable after retries. Disabling.');
        this.canMakePayment = false;
        return;
      }

      setTimeout(this.canDoGooglePay, 300);
      return;
    }

    console.log('google', google);
    if (typeof google === 'undefined' || !google.payments?.api) {
      console.error('Google Pay API is not available.');
      return;
    }
    
    console.info('Initializing Google Pay PaymentsClient', this.EPayService?.ePay?.paymentPage.environment);

    var enviroment = 'PRODUCTION';
    if (this.IsInTestingMode()) {
      enviroment = 'TEST'
    }

    this.paymentsClient = new google.payments.api.PaymentsClient({ environment: enviroment });

    console.log("enviroment", enviroment);

    if (this.EPayService.ePay && this.paymentsClient) {
      _each(this.EPayService.ePay.xmlPayment.creditCards.cards, (cardModel: Session_CardModel) => {
        console.info('cardModel', cardModel);
        if (cardModel.cardId === "GOGLE") {
              this.canMakePayment = true;
        }
      }
      );
    }
  }

  public googlePay(): void {
    var result: any;
    if (!this.paymentsClient || !this.EPayService?.ePay?.paymentPage?.totalAmount) {
      console.error('Google Pay client is not initialized or amount is missing.');
      return;
    }

    var merchantName = this.EPayService?.ePay?.xmlPayment.agency.agency;// this.EPayService?.ePay?.paymentPage.merchantName;
    
    if (!merchantName || merchantName == '') {
      merchantName = 'WVSTO';
    }

    const paymentRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [{
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
          allowedCardNetworks: this.allowedCardTypes()
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'cardconnect', 
            gatewayMerchantId: this.EPayService?.ePay?.paymentPage.gatewayMerchantId?.toString() //*
          }
        }
      }],
      merchantInfo: {
        merchantName: merchantName, //*
        merchantId: this.EPayService?.ePay?.paymentPage.googleMerchantId ? this.EPayService?.ePay?.paymentPage.googleMerchantId : ''
      },
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPrice: this.EPayService.ePay.paymentPage.totalAmount.toString(),
        currencyCode: 'USD',
        countryCode: 'US'
      }
    };

    console.log('paymentRequest', paymentRequest);

    this.paymentsClient.loadPaymentData(paymentRequest)
      .then((paymentData: any) => {
        console.log('Google Pay paymentData:', paymentData);

        this.CardConnectService.postGoogle(this.EPayService.Origin() + '', paymentData.paymentMethodData.tokenizationData.token).subscribe((data: any) => {
          console.info('from card connect', data);
          if (this.EPayService.ePay?.paymentPage.cardData && this.EPayService.ePay.paymentPage.credit_card) {
            this.EPayService.ePay.paymentPage.cardData.expiry = "";
            this.EPayService.ePay.paymentPage.cardData.fullName = this.EPayService.ePay.paymentPage.cardHolderName;
            this.EPayService.ePay.paymentPage.cardData.token = data.token;
            _each(this.EPayService.ePay.paymentPage.credit_card, (req: Session_Credit_Card_RequestModel) => {
              req.response.token = data.token;
            });
            this.makePayment.emit();
          }
        })
      })
      .catch((err: any) => {
        console.error('Google Pay failed:', err);
      });
  }

  private allowedCardTypes = (): string[] => {
    const brands: string[] = [];

    if (this.EPayService?.ePay?.xmlPayment?.creditCards?.cards) {
      _each(this.EPayService.ePay.xmlPayment.creditCards.cards, (card: Session_CardModel) => {
        switch (card.cardId) {
          case 'VISA': brands.push('VISA'); break;
          case 'MAST': brands.push('MASTERCARD'); break;
          case 'DISC': brands.push('DISCOVER'); break;
          case 'AMER': brands.push('AMEX'); break;
        }
      });
    }

    return brands;
  }
}
